module.exports = __webpack_public_path__ + "static/media/tlyferewards.1e27c605.svg";